import script from "./RadioYesNo.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioYesNo.vue?vue&type=script&setup=true&lang=js"

import "./RadioYesNo.vue?vue&type=style&index=0&id=5be0db93&scoped=true&lang=scss"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be0db93"]])

export default __exports__